module.exports = __webpack_public_path__ + "static/visual_1_2_dont-13137f91eaf031c258697b64364cceab.png";